//@flow
// import React from 'react';
import Dispatcher from 'app/Dispatcher';
import {
  Cookies
} from 'react-cookie';

const ActionTypes = {
  SET_BRAND_FOCUS: 'SET_BRAND_FOCUS',
};

const Actions = {

  setBrandFocus(brand?: Object) {

    Dispatcher.dispatch({
      type: ActionTypes.SET_BRAND_FOCUS,
      brand: brand
    });
    // if (brand) {
    //set cookie
    const cookies = new Cookies();
    cookies.set('brand', brand ? { id: brand.id, name: brand.label } : null, {
      path: '/'
    });
    // } 
  },
}

export {
  Actions,
  ActionTypes
};